import {
  ActionTakenLabelDto,
  ProjectActionTakenLabelsResponse,
  SetActionTakenLabelsRequest,
} from '../../api-client/autogenerated';
import { ApiClient } from '../../api-client/api-client';
import {
  ActionTakenLabelConfig,
  ActionTakenLabelOverrides,
} from '../../scripts/action-taken-labels';

/** Split the API's rows into the two things consumers need: display labels and the disabled set. */
export const toActionTakenLabelConfig = (rows: ActionTakenLabelDto[]): ActionTakenLabelConfig => ({
  labels: rows.reduce<ActionTakenLabelOverrides>((acc, { actionTaken, label }) => {
    if (label) acc[actionTaken] = label;
    return acc;
  }, {}),
  disabled: rows.filter((row) => row.isEnabled === false).map((row) => row.actionTaken),
});

// GET //

/** Labels for a project, readable by anyone with access to that project. */
export const getActionTakenLabelsByProjectId = async (
  projectId: string,
): Promise<ProjectActionTakenLabelsResponse> => {
  const response = await ApiClient.getActionTakenLabelsByProjectId({ projectId });
  return response.data;
};

/** Labels for a subscriber, readable by that subscriber's admins (and site admins). */
export const getActionTakenLabelsBySubscriberId = async (
  subscriberId: string,
): Promise<ActionTakenLabelDto[]> => {
  const response = await ApiClient.getActionTakenLabelsBySubscriberId({ subscriberId });
  return response.data;
};

// PUT //

/** Replace the subscriber's whole label set. Omitting an action resets it to the built-in label. */
export const setActionTakenLabelsBySubscriberId = async (
  subscriberId: string,
  body: SetActionTakenLabelsRequest,
): Promise<ActionTakenLabelDto[]> => {
  const response = await ApiClient.setActionTakenLabelsBySubscriberId({
    subscriberId,
    setActionTakenLabelsRequest: body,
  });
  return response.data;
};
